'use client';

import { tv } from 'tailwind-variants';

import { Body } from '../typography/Body';
import { Card, CardContent, CardHeader } from './Card';
import { FlexContainer } from './FlexContainer';

export interface MetricChartCardProps {
  title: string;
  value: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

const metricChartCard = tv({
  base: 'h-full w-full gap-2 py-3',
});

export function MetricChartCard({
  title,
  value,
  children,
  actions,
  footer,
  className,
}: MetricChartCardProps): React.ReactElement {
  const headline = (
    <>
      <Body className="text-content-secondary" size="sm">
        {title}
      </Body>
      <Body className="text-content-primary" size="lg" weight="semibold">
        {value}
      </Body>
    </>
  );

  return (
    <Card className={metricChartCard({ className })} padding="sm">
      <CardHeader>
        {actions ? (
          <FlexContainer className="w-full gap-3" items="start" justify="between" wrap="wrap">
            <FlexContainer className="gap-0" direction="column" grow shrink>
              {headline}
            </FlexContainer>
            {actions}
          </FlexContainer>
        ) : (
          <FlexContainer className="gap-0" direction="column">
            {headline}
          </FlexContainer>
        )}
      </CardHeader>
      <CardContent>
        {children}
        {footer}
      </CardContent>
    </Card>
  );
}
